const slugify = (value) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const parseAsciiDocHeader = (
  raw,
  { fallbackSource = "", fallbackTitle = "" } = {},
) => {
  const lines = raw.split(/\r?\n/);
  const attributes = {};
  let cursor = 0;
  let title = "";

  if (lines[cursor]?.startsWith("= ")) {
    title = lines[cursor].slice(2).trim();
    cursor += 1;
  }

  if (lines[cursor] && !lines[cursor].startsWith(":") && lines[cursor].trim()) {
    cursor += 1;
  }

  while (cursor < lines.length) {
    const line = lines[cursor];
    const match = line.match(/^:([a-z0-9_-]+):\s*(.+)$/i);

    if (!match) {
      break;
    }

    attributes[match[1].toLowerCase()] = match[2].trim();
    cursor += 1;
  }

  while (cursor < lines.length && !lines[cursor].trim()) {
    cursor += 1;
  }

  const bodyLines = lines.slice(cursor);
  const firstParagraph = [];

  for (const line of bodyLines) {
    const trimmed = line.trim();

    if (!trimmed) {
      if (firstParagraph.length) {
        break;
      }

      continue;
    }

    if (
      trimmed.startsWith("=") ||
      trimmed.startsWith(":") ||
      trimmed === "----" ||
      trimmed.startsWith("[source,") ||
      trimmed.startsWith("* ") ||
      trimmed.startsWith("- ")
    ) {
      continue;
    }

    firstParagraph.push(trimmed);
  }

  const normalizedSource = fallbackSource.replace(/\.adoc$/i, "");

  return {
    title: title || fallbackTitle || normalizedSource,
    slug:
      attributes.slug || (normalizedSource ? slugify(normalizedSource) : ""),
    published: attributes.published || "",
    summary: attributes.summary || firstParagraph.join(" "),
    tags: attributes.tags
      ? attributes.tags
          .split(",")
          .map((tag) => tag.trim())
          .filter(Boolean)
      : [],
    attributes,
    bodyLines,
  };
};

export { slugify };
